// extracted by css-extract-rspack-plugin
export default {"form":"MoveDialogForm-module__form__w9_LG","autoComplete":"MoveDialogForm-module__autoComplete__LQ0zj","datePickerAnchor":"MoveDialogForm-module__datePickerAnchor__HCbSa"};